import type { State } from '@avalara/types/reducer-states';

export const selectState = (state: State): State => state;

export const selectIsNonAdmin = (state: State): boolean => state.account.isAdmin === false;
